import ExerciseAPI from '@/app/apis/main/exercise/exercise-api.js';

export default {
	/**
	* @param {*} exerciseDetails
	*/
	async postExercise(exerciseDetails) {
		return ExerciseAPI.postExercise(exerciseDetails);
	},

	/**
	* @param {*} exerciseDetails
	* @return {*} exercise list
	*/
	async getExercise(exerciseDetails) {
		return ExerciseAPI.getExercise(exerciseDetails);
	},

	/**
	* @param {*} exerciseId
	*/
	async deleteExerciseById(exerciseId) {
		return ExerciseAPI.deleteExerciseById(exerciseId);
	},

	/**
	* @return NO CONTENT
	*/
	async updateExercise(exerciseDetails, exerciseId) {
		return ExerciseAPI.putExercise(exerciseDetails, exerciseId);
	}
};